import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const FolderLine = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-test="folder-line-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M21 7.27273C21 6.83874 20.8276 6.42252 20.5207 6.11564C20.2138 5.80877 19.7976 5.63636 19.3636 5.63636H9.54545L8.38909 4.47891C8.23707 4.32698 8.0566 4.20649 7.858 4.12432C7.6594 4.04215 7.44656 3.9999 7.23164 4H4.63636C4.20237 4 3.78616 4.1724 3.47928 4.47928C3.1724 4.78616 3 5.20237 3 5.63636V17.0909C3 17.5249 3.1724 17.9411 3.47928 18.248C3.78616 18.5549 4.20237 18.7273 4.63636 18.7273H19.3636C19.7976 18.7273 20.2138 18.5549 20.5207 18.248C20.8276 17.9411 21 17.5249 21 17.0909V7.27273Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
